import _ from 'lodash';

import { apiRequest } from 'src/api';

const docusignURLDataAdapter = data => ({
  url: _.get(data, 'docusign_link', null),
});

export const getNDADocusignURL = async financialInstitutionId => {
  return apiRequest({
    url: `/api/v1/fis/${financialInstitutionId}/nda/`,
    method: 'GET',
    responseDataAdapter: docusignURLDataAdapter,
  });
};

export const getBgDocusignURL = async financialInstitutionId => {
  return apiRequest({
    url: `/api/v1/fis/${financialInstitutionId}/bg_consent/`,
    method: 'GET',
    responseDataAdapter: docusignURLDataAdapter,
  });
};
